import React, { useState } from 'react';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
const SignInput = ({ label, name, Icon, type, value, changeHandler, ...props }) => {
    const [hidden, setHidden] = useState(true);
    return (
        <label htmlFor={name} className="labeled_input">
            <p>{label}</p>
            <input
                id={name}
                type={!hidden ? 'text' : type}
                {...props}
                className="labeled_input_field signup"
                value={value}
                onChange={changeHandler}
            />
            {Icon && <Icon className="signup_inpute_icon" />}
            {Icon && type === 'password' && hidden && (
                <VisibilityIcon
                    onClick={() => {
                        setHidden((prev) => !prev);
                    }}
                    className="signin_input_content_icon"
                />
            )}
            {Icon && type === 'password' && !hidden && (
                <VisibilityOffIcon
                    onClick={() => {
                        setHidden((prev) => !prev);
                    }}
                    className="signin_input_content_icon"
                />
            )}
        </label>
    );
};

export default SignInput;
